import { Injectable, signal, WritableSignal } from '@angular/core';
import { ResourcePoiIdentificationCrate } from '@cue/data';

// UZ SE V NAVIGATION Nepouziva - igorovat a pak smazat
@Injectable()
export class CurrentMapItemService {
  startItemResourceOrPoi: WritableSignal<ResourcePoiIdentificationCrate> = signal(null);
  targetItemResourceOrPoi: WritableSignal<ResourcePoiIdentificationCrate> = signal(null);

  currentItemResourceId: WritableSignal<number> = signal(null);
  currentItemQrCodeId: WritableSignal<string> = signal(null);

  updateCurrentItemId(resourceId: number, qrCodeId: string) {
    //POI has resourceId AND qrCodeId - but we want to highlight ONLY QRCODE
    if (resourceId && qrCodeId) {
      this.currentItemQrCodeId.set(null);
      this.currentItemResourceId.set(resourceId);
      return;
    }
    this.currentItemResourceId.set(resourceId);
    this.currentItemQrCodeId.set(qrCodeId);
  }

  updateStartResourcePOI(resourceId: number, qrCodeId: string, areaId?: number) {
    this.startItemResourceOrPoi.set({
      resourceId: resourceId,
      qrCodeId: qrCodeId,
      areaId: areaId,
    });
  }

  updateTargetResourcePOI(resourceId: number, qrCodeId: string, areaId?: number) {
    this.targetItemResourceOrPoi.set({
      resourceId: resourceId,
      qrCodeId: qrCodeId,
      areaId: areaId,
    });
  }

  resetStartTargetAndCurrentItemPoints(isKioskMode: boolean) {
    if (!isKioskMode) {
      this.startItemResourceOrPoi.set(null);
    }
    this.targetItemResourceOrPoi.set(null);
    this.currentItemResourceId.set(null);
    this.currentItemQrCodeId.set(null);
  }
}
